import { Link, useNavigate } from 'react-router-dom';
import GetIcon from '../../utils/Icon';
import useCustomNavigate from "../../Hook/useCustomNavigate";

const Button = ({
  children,
  onClick,
  to,
  state,
  iconName,
  iconSize = 12,
  className = '',
  style = {},
  display = 'flex',
  type = 'button',
  disabled = false,
  imgSrc,
  imgStyle = { width: '21px' },
  iconWrapperStyle,
  iconWrapperClassName = '',
  align = 'center', 
  iconPosition = 'left',
  iconBoxClassName = '', 
  text, 
}) => {
  const navigate = useCustomNavigate();

  const handleClick = (e) => {
    if (to) {
      navigate(to, { state });
    }
    if (onClick) {
      onClick(e);
    }
  };

  // Common button styles and classes
  const baseClasses = 'mb-0 align-items-center';
  const buttonStyle = {
    textDecoration: 'none',
    display: display,
    border:"0px",
    justifyContent: align === 'center' ? 'center' : 
                   align === 'start' ? 'flex-start' : 'flex-end',
    ...style,
  };

  // Render icon with optional wrapper
  const renderIcon = () => {
    if (!iconName) return null;
    
    const icon = <GetIcon iconName={iconName} size={iconSize} />;
    
    if (iconWrapperStyle || iconWrapperClassName) {
      return (
        <span 
          className={` justify-content-center align-items-center rounded ${iconWrapperClassName}`}
          style={iconWrapperStyle}
        >
          {icon}
        </span>
      );
    }
    
    return icon;
  };

  // Render icon box (for dropdown-style icons)
  const renderIconBox = () => {
    if (!iconName) return null;
    
    return (
      <span className={`iconbox ps-2 ${iconBoxClassName}`}>
        <GetIcon iconName={iconName} size={iconSize} />
      </span>
    );
  };

  if (to && imgSrc) {
    return (
      <Link to={to} className={className} style={buttonStyle}>
        <img src={imgSrc} alt="button icon" style={imgStyle} />
      </Link>
    );
  }

  const Tag = type === 'button' ? 'button' : 'p';

  return (
    <Tag
      className={`${baseClasses} ${className}`}
      style={buttonStyle}
      onClick={handleClick}
      type={type === 'button' ? 'button' : undefined}
      disabled={disabled}
    >
      {/* Icon on left */}
      {iconPosition === 'left' && renderIcon()}
      {iconPosition === 'left' && iconName && (children || text) && ' '}
      
      {/* Content */}
      {text || children}
      
      {/* Icon on right (for dropdown) */}
      {iconPosition === 'right' && ' '}
      {iconPosition === 'right' && renderIconBox()}
    </Tag>
  );
};

export default Button;